import { TFunction } from 'next-i18next'
import { BigOrderItem, Order } from 'src/core/models'
import { getFormatedPrice, getOrderItemUnitPrice, getOrderItemProjectUnitPrice, getOrderItemTotal, getOrderItemUnit } from 'src/core/helpers'

export interface OrderProjectDetailLabel {
  label: string,
  strongLabel: string | number,
  secondLabel: string,
  show: boolean
}

const getOrderItemVatBankTransfer = (orderItem: BigOrderItem): number => {
  // TODO: change in the future please
  const total: number = orderItem.price / orderItem.order_price * orderItem.vat
  return total
}

export const orderDetailsInProjectCurrency = (
  t: TFunction, orderItem: BigOrderItem, order: Order, code: string, divider: string
): OrderProjectDetailLabel[] => {

  const details: OrderProjectDetailLabel[] = [
    {
      label: t('Transactions.Pricing'),
      strongLabel: `${getOrderItemProjectUnitPrice(orderItem, code)} ${divider}`,
      secondLabel: getOrderItemUnit(orderItem),
      show: true
    },
    {
      label: t('Transactions.Amount'),
      strongLabel: orderItem.amount,
      secondLabel: getOrderItemUnit(orderItem),
      show: !orderItem.is_free_donation
    },
    {
      label: t('Transactions.Subtotal'),
      strongLabel: `${getOrderItemTotal(orderItem, order, orderItem.project_currency_code || code, true)}`,
      secondLabel: null,
      show: true
    }
  ]

  if (orderItem.customerInvoice === null) {
    details.splice(2, 0, {
      label: t('Transactions.VAT'),
      strongLabel: getFormatedPrice(
        +orderItem.invoiceP2pVatAmountProjectCurrency || 
        getOrderItemVatBankTransfer(orderItem),
        orderItem.project_currency_code || code
      ),
      secondLabel: null,
      show: true
    })
  }

  return details
}


export const orderDetailsInCustomerCurrency = (
  t: TFunction, orderItem: BigOrderItem, code: string, divider: string
): OrderProjectDetailLabel[] => [
  {
    label: t('Transactions.UnitPrice'),
    strongLabel: `${getFormatedPrice(orderItem.user_unit_price, code)} ${divider}`,
    secondLabel: getOrderItemUnit(orderItem),
    show: true
  },
  {
    label: t('Deposits.Total'),
    strongLabel: `${getFormatedPrice(orderItem.user_total_amount, code)}`,
    secondLabel: null,
    show: true
  },
]

export const orderDetailsInCustomerCurrencyV2 = (
  t: TFunction, orderItem: BigOrderItem, order: Order, code: string, divider: string
): OrderProjectDetailLabel[] => {

  const details: OrderProjectDetailLabel[] = [
    {
      label: t('Transactions.Pricing'),
      strongLabel: `${getOrderItemUnitPrice(orderItem, orderItem.order_currency || code)} ${divider}`,
      secondLabel: getOrderItemUnit(orderItem),
      show: true
    },
    {
      label: t('Transactions.Amount'),
      strongLabel: orderItem.amount,
      secondLabel: getOrderItemUnit(orderItem),
      show: !orderItem.is_free_donation
    },
    {
      label: t('Transactions.Subtotal'),
      strongLabel: `${getOrderItemTotal(orderItem, order, orderItem.order_currency || code, true)}`,
      secondLabel: null,
      show: true
    }
  ]
  return details
}

export const oldOrderDetailsLabels = (
  t: TFunction, orderItem: BigOrderItem, order: Order, code: string, divider: string
): OrderProjectDetailLabel[] => [
  {
    label: t('Transactions.Pricing'),
    strongLabel: `${getFormatedPrice(orderItem.project_price, code)} ${divider}`,
    secondLabel: getOrderItemUnit(orderItem),
    show: true
  },
  {
    label: t('Transactions.Amount'),
    strongLabel: orderItem.amount,
    secondLabel: getOrderItemUnit(orderItem),
    show: !orderItem.is_free_donation
  },
  {
    label: t('Transactions.VAT'),
    strongLabel: getFormatedPrice(+orderItem.breakdownP2pTaxAmount || orderItem.vat, code),
    secondLabel: null,
    show: true
  },
  {
    label: t('Transactions.Subtotal'),
    strongLabel: `${getOrderItemTotal(orderItem, order, code)}`,
    secondLabel: null,
    show: true
  }
]
